export default function () {
  return {
    // ORGANISATION
    organisations: [],
    organisation: null,
    // DASHBOARD/STATS
    postCounter: null,
    studentReach: 0,
    schoolsCount: 0,
    schools: [],
    regions: [],
    mailouts: 0,
    postCategories: null,
    postCategoriesCount: 0,
    topPosts: [],
    // POSTS
    posts: [],
    organisationActivity: null,
    postsStats: [],
    // CONNECTIONS
    connections: [],
    connectionsCounter: null,
    connectionsWithStats: [],
    connectionsPagination: null,
    connectionsImpressionsCount: 0,
    connectionsViewsCount: 0,
    connectionsContactedCount: 0,
    // ACCOUNTS
    accounts: [],
    // PUBLIC PROFILE
    organisationProfile: null,
    organisationProfilePosts: [],
    organisationProfilePostsPagination: null,
    organisationProfileConnections: [],
  }
}
